/* IndiaSize Variant Selector */
(function(){
  'use strict';

  function init(wrap){
    if (wrap.dataset.insInit === '1') return;
    wrap.dataset.insInit = '1';

    var pid = wrap.getAttribute('data-product-id');

    var dataNode = document.querySelector('script[data-ins-variants="' + pid + '"]');
    if (!dataNode) return;

    var V;
    try { V = JSON.parse(dataNode.textContent); }
    catch(e){ console.error('IndiaSize: variant JSON parse failed', e); return; }

    var configNode = document.querySelector('script[data-ins-config="' + pid + '"]');
    var CFG = { currency: 'INR' };
    if (configNode) {
      try { CFG = JSON.parse(configNode.textContent); } catch(e){}
    }

    var BT = [
      { name:'Athletic',  drop:'Chest \u2212 Waist = 15 to 20 cm',     desc:'Broad shoulders tapering sharply to a narrow waist \u2014 a classic V-shape build.' },
      { name:'Slim',      drop:'Chest \u2212 Waist = 10 to 15 cm',     desc:'A lean build with a noticeable but moderate chest-to-waist difference.' },
      { name:'Regular',   drop:'Chest \u2212 Waist = 5 to 10 cm',      desc:'A balanced build with a moderate taper. The most common body type among Indian men.' },
      { name:'Full Body', drop:'Chest \u2212 Waist = 0 to 5 cm',       desc:'A fuller build where chest and waist are close in size. Needs room across the torso.' },
      { name:'Corpulent', drop:'Chest \u2212 Waist = 0 to \u22125 cm', desc:'A rounded midsection where the waist meets or exceeds the chest. Needs generous allowance.' }
    ];

    // Merge images from config
    if (CFG.bodyTypeImages && Array.isArray(CFG.bodyTypeImages)) {
      BT.forEach(function(b, i){ b.img = CFG.bodyTypeImages[i] || ''; });
    }

    var bd = document.getElementById('ins-mbd-' + pid);
    if (!bd) return;

    var mT = document.getElementById('ins-mt-' + pid);
    var mS = document.getElementById('ins-ms-' + pid);
    var mI = document.getElementById('ins-mi-' + pid);
    var mN = document.getElementById('ins-mn-' + pid);
    var mD = document.getElementById('ins-md-' + pid);
    var mC = document.getElementById('ins-mc-' + pid);
    var mX = document.getElementById('ins-mx-' + pid);
    var mP = document.getElementById('ins-mp-' + pid);
    var mQ = document.getElementById('ins-mq-' + pid);
    var idx = 0;

    function ph(url){ return !url || url.indexOf('YOUR-STORE') !== -1; }

    function showModal(i){
      var b = BT[i]; if(!b) return; idx = i;
      mT.textContent = b.name + ' Body Type';
      mS.textContent = b.drop;
      mN.textContent = b.name;
      mD.textContent = b.drop;
      mC.textContent = b.desc;
      mP.style.visibility = i === 0 ? 'hidden' : 'visible';
      mQ.style.visibility = i === BT.length - 1 ? 'hidden' : 'visible';
      mI.innerHTML = '';

      if (ph(b.img)) {
        mI.innerHTML = '<div class="ins-modal-img-ph"><svg width="44" height="44" viewBox="0 0 44 44" fill="none"><rect x="1" y="1" width="42" height="42" rx="5" stroke="currentColor" stroke-width="1.5"/><circle cx="16" cy="16" r="5" stroke="currentColor" stroke-width="1.5"/><path d="M1 32l11-9 8 7 6-5 18 16" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg><span>Upload image for <strong>' + b.name + '</strong></span></div>';
      } else {
        var img = new Image();
        img.src = b.img;
        img.alt = b.name;
        img.loading = 'lazy';
        mI.appendChild(img);
      }

      bd.classList.add('open');
      document.body.style.overflow = 'hidden';
      mX.focus();
    }

    function closeModal(){
      bd.classList.remove('open');
      document.body.style.overflow = '';
    }

    mX.addEventListener('click', closeModal);
    bd.addEventListener('click', function(e){ if (e.target === bd) closeModal(); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && bd.classList.contains('open')) closeModal();
    });
    mP.addEventListener('click', function(){ if (idx > 0) showModal(idx - 1); });
    mQ.addEventListener('click', function(){ if (idx < BT.length - 1) showModal(idx + 1); });

    wrap.querySelectorAll('.ins-link-toggle').forEach(function(link){
      link.addEventListener('click', function(){
        var id = link.getAttribute('data-target');
        var el = document.getElementById(id);
        if (el) el.classList.toggle('open');
      });
    });

    function getSel(){
      return {
        H: (wrap.querySelector('[data-option="HeightRange"].active') || {}).dataset && wrap.querySelector('[data-option="HeightRange"].active').dataset.value,
        B: (wrap.querySelector('[data-option="BodyType"].active') || {}).dataset && wrap.querySelector('[data-option="BodyType"].active').dataset.value,
        C: (wrap.querySelector('[data-option="ChestSize"].active') || {}).dataset && wrap.querySelector('[data-option="ChestSize"].active').dataset.value
      };
    }

    function findVariant(s){
      return V.find(function(v){
        return v.option1 === s.H && v.option2 === s.B && v.option3 === s.C;
      }) || null;
    }

    function getInput(){
      var f = wrap.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      return f ? f.querySelector('input[name="id"]') : null;
    }

    function applyVariant(v){
      var inp = getInput();
      if (!v) {
        if (inp) inp.value = '';
        setBtn(false, 'Select all options');
        return;
      }

      if (inp) {
        inp.value = v.id;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
        inp.dispatchEvent(new Event('input', { bubbles: true }));
      }

      var pr = (v.price / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: CFG.currency || 'INR',
        minimumFractionDigits: 0
      });

      ['.price__regular .price-item--regular', '.product__price', '[data-product-price]', '.product-single__price', '.price-item--regular'].forEach(function(s){
        var e = document.querySelector(s);
        if (e) e.textContent = pr;
      });

      setBtn(v.available, v.available ? 'Add to cart' : 'Sold out');
      document.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: v, productId: pid }
      }));
    }

    function setBtn(on, lbl){
      var b = document.querySelector('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] [type="submit"]');
      if (!b) return;
      b.disabled = !on;
      if (b.children.length === 0) b.textContent = lbl;
    }

    function refreshAvail(){
      var s = getSel();
      ['HeightRange','BodyType','ChestSize'].forEach(function(opt){
        wrap.querySelectorAll('[data-option="' + opt + '"]').forEach(function(btn){
          var h = opt === 'HeightRange' ? btn.dataset.value : s.H;
          var b = opt === 'BodyType'    ? btn.dataset.value : s.B;
          var c = opt === 'ChestSize'   ? btn.dataset.value : s.C;

          var ok = V.some(function(v){
            return (!h || v.option1 === h) && (!b || v.option2 === b) && (!c || v.option3 === c) && v.available;
          });

          btn.classList.toggle('unavailable', !ok);

          if (!ok && btn.classList.contains('active')) {
            btn.classList.remove('active');
            btn.setAttribute('aria-pressed', 'false');
          }
        });
      });
    }

    function setActive(opt, btn){
      wrap.querySelectorAll('[data-option="' + opt + '"]').forEach(function(b){
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
    }

    function setDisplay(opt, val){
      var el = wrap.querySelector('[data-ins-display="' + opt + '"]');
      if (el) el.textContent = opt === 'ChestSize' ? val + ' cm' : val;
    }

    wrap.addEventListener('click', function(e){
      var eg = e.target.closest('.ins-see-eg');
      if (eg) {
        e.stopPropagation();
        showModal(parseInt(eg.dataset.bi, 10));
        return;
      }

      var btn = e.target.closest('[data-option]');
      if (!btn || btn.classList.contains('unavailable')) return;

      setActive(btn.dataset.option, btn);
      setDisplay(btn.dataset.option, btn.dataset.value);
      refreshAvail();
      applyVariant(findVariant(getSel()));
    });

    // Parse height labels into feet + cm rows
    wrap.querySelectorAll('[data-option="HeightRange"]').forEach(function(btn){
      var val   = btn.dataset.value || '';
      var open  = val.indexOf('(');
      var close = val.lastIndexOf(')');
      var fEl   = btn.querySelector('.ins-height-feet');
      var cEl   = btn.querySelector('.ins-height-cm');

      if (open !== -1 && close !== -1 && close > open) {
        if (fEl) fEl.textContent = val.slice(0, open).trim();
        if (cEl) cEl.textContent = val.slice(open + 1, close).trim();
      } else {
        if (fEl) fEl.textContent = val;
        if (cEl) cEl.textContent = '';
      }
    });

    refreshAvail();
    var pre = V.find(function(v){ return v.available; });
    if (pre) applyVariant(pre);
  }

  function bootstrap(){
    document.querySelectorAll('.ins-wrap[data-product-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
